// src/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children, language, setLanguage }) => {
  const t = translations[language] || translations.english;
  const isRtl = language === 'arabic';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRtl }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    // fallback for components not wrapped in provider
    const ws = localStorage.getItem('currentWorkspace');
    const lang = ws ? (JSON.parse(ws).language || 'english') : 'english';
    return {
      language: lang,
      t: translations[lang] || translations.english,
      isRtl: lang === 'arabic',
      setLanguage: () => {}
    };
  }
  return ctx;
};

export default LanguageContext;
